.specialDetailSummary {
  width: 100%;
  height: min-content;
  position: relative;
}

.specialDetailBanner {
  position: fixed;
  left: 0;
  right: 0;
  z-index: var(--layers-header);
  transform: translateY(-100%);
  transition: transform 160ms ease;
  visibility: hidden;
}

:global(#special-detail-layout.summary-not-at-top) .specialDetailBanner {
  transform: translateY(0);
  visibility: visible;
}

.baseLayout {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
}

.loadingSkeleton {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.loadingSkeletonSummary {
  width: 100%;
  height: 210px;
}

.loadingSkeletonContent {
  width: 100%;
}

.filterSkeletonDesktop {
  display: none;
}

.productGridSkeleton {
  display: grid;
  gap: 24px;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}

@media (--reefer-media-desktop-sm-min) {
  .loadingSkeleton {
    flex-direction: row;
  }

  .loadingSkeletonSummary {
    width: 40%;
    height: 420px;
  }

  .loadingSkeletonContent {
    width: 60%;
  }

  .filterSkeletonMobile {
    display: none;
  }

  .filterSkeletonDesktop {
    display: flex;
  }

  .productGridSkeleton {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  .specialDetailSummary {
    position: sticky;
    top: calc(var(--header-height));
    height: calc(100vh - 48px - var(--header-height));
    max-width: 468px;
    flex-shrink: 0;
    overflow: hidden;
  }

  .specialDetailBanner {
    display: none;
    visibility: hidden;
  }

  .baseLayout {
    flex-direction: row;
    gap: 48px;
  }
}
